import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { 
  Listing, 
  Filters
} from 'components/Marketing/Campaigns'

const Campaigns = (props) => {
  return (
    <div className='fadeIn' style={{ width:'100%', display:'flex' }}>
      <Filters />
      <Listing />
    </div>
  )
}

export default connect((state) => ({ marketing: state.marketing }))(withRouter(Campaigns))
